<template>
    <div class="card-attributes block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/attribute.png" alt="">
                        </div>

                        <h4>Setup User Attribute</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <p>Set a value for an existing user attribute or add a new one. Use it to segment users for broadcast
                        subscriptions, to define bot flow scenarios, or to analyze users' activity. Note that you can use arithmetic
                        expressions and attributes in the Value field.</p>
                    <div
                        class="attributes-list delete-wrapper"
                        v-for="(attribute, index) in data.attributes"
                    >
                        <v-layout row wrap>
                            <v-flex xs6>
                                <label >Attribute</label>
                                <v-text-field
                                        outline
                                        v-model="attribute.attribute"
                                        :error="!attribute.attribute"
                                        :error-messages="!attribute.attribute? 'Attribute is Required':'' "
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <label >Value</label>
                                <v-text-field
                                        outline
                                        v-model="attribute.value"
                                        :error="!attribute.value"
                                        :error-messages="!attribute.value? 'Attribute Value is Required':'' "
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-btn
                                @click="deleteAttribute(index)"
                                fab small color=""
                                class="delete-button"
                        ><v-icon small color="#666">delete_outline</v-icon></v-btn>
                    </div>
                    <v-btn
                            large round flat block
                            class="primary--text"
                            @click="addAttribute"
                    >
                        <v-icon>add_circle_outline</v-icon>
                        Add New User Attribute
                    </v-btn>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    export default {
        name: "card-audio",
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common
            }
        },
        mounted() {

        },
        methods: {
            addAttribute() {
                this.data.attributes.push({
                    id:0,
                    attribute:'',
                    value:''
                })
            },
            deleteAttribute(index) {
                this.data.attributes.splice(index, 1)
            },
            getVariables() {
                this.$http_bot.get('/blocks/variables/available')
                    .then(response=>{
                        const variables = []
                        for (let i = 0; i<response.data.length; i++) {
                            if (response.data[i].variable !== '') {
                                variables.push(response.data[i])
                            }
                        }
                        this.$store.dispatch('setVariables', variables)
                    })
                    .catch(error=>{
                        if (error.response.status === 401) {
                            common.logOut()
                        }
                    })
            },
        },
        computed: {

        },
        watch: {
            data: {
                handler(val){
                    this.getVariables()
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>